import { getStore } from '~/mobx/AppStore';

const getStandAdminId = () => {
    const { ballotStore } = getStore();
    return ballotStore.standAdminId;
};
export default getStandAdminId;
